module.exports = __webpack_public_path__ + "img/bg_main06_mask_m.b5ae2560.png";